"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _reactRouterDom = require("react-router-dom");
var _SidebarHeading = _interopRequireDefault(require("../SidebarHeading"));
var _SidebarDivider = _interopRequireDefault(require("../SidebarDivider"));
var _SidebarGroup = _interopRequireDefault(require("../SidebarGroup"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var allowedChildTypes = [_SidebarHeading["default"], _SidebarDivider["default"], _SidebarGroup["default"]];

/**
 * The primary navigation element within an Anypoint product.
 */
var Sidebar = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Sidebar, _React$Component);
  function Sidebar(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Sidebar);
    _this = _callSuper(this, Sidebar, [props]);

    // Validate that child elements are only of the allowedChildTypes
    _react["default"].Children.forEach(_this.props.children, function (child) {
      if (!allowedChildTypes.includes(child.type)) {
        var typesStr = allowedChildTypes.map(function (type) {
          return type.name;
        }).join('> and <');
        throw new Error("Tag <".concat(child.type, "> is not supported inside of a Sidebar. Allowed tags: <").concat(typesStr, ">."));
      }
    });
    return _this;
  }
  (0, _createClass2["default"])(Sidebar, [{
    key: "renderBackLink",
    value: function renderBackLink() {
      var _this$props = this.props,
        backLabel = _this$props.backLabel,
        backHref = _this$props.backHref,
        theme = _this$props.theme;
      if (backLabel && backHref) {
        var isAbsoluteOrHashLink = backHref.indexOf('#') === 0 || backHref.indexOf('/') === 0;
        if (!isAbsoluteOrHashLink) {
          throw new Error('Sidebar Links must begin with either a "#" or "/" for correct navigation behavior');
        }
        // Hash routes do not reload the page, and so use anchor tags. Absolute routes need to use
        // react-router-dom Links so that they do not reload the page. Note that we assume that all
        // apps use react-router for routing.
        var backIcon = /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          className: theme.icon,
          name: "back",
          size: "xs"
        });
        var isAbsolutePath = backHref.indexOf('/') === 0;
        return isAbsolutePath ? /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
          className: theme.menuBack,
          to: backHref
        }, backIcon, backLabel) : /*#__PURE__*/_react["default"].createElement("a", {
          className: theme.menuBack,
          href: backHref
        }, backIcon, backLabel);
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        className = _this$props2.className,
        testId = _this$props2.testId,
        theme = _this$props2.theme,
        envSwitcher = _this$props2.envSwitcher,
        children = _this$props2.children;
      return /*#__PURE__*/_react["default"].createElement("nav", {
        className: (0, _classnames["default"])(className, theme.sidebar),
        "data-test-id": testId
      }, envSwitcher, this.renderBackLink(), children);
    }
  }]);
  return Sidebar;
}(_react["default"].Component);
(0, _defineProperty2["default"])(Sidebar, "defaultProps", {
  theme: {},
  testId: 'anypoint-sidebar'
});
//# sourceMappingURL=Sidebar.js.map